import React, { useState, useEffect } from "react";
import "./Home.css";
import Product from "./Product";
import useFetch from "./useFetch";
import useDebounce from "./useDebounce";

// API URL from environment variable
const API_URL = "https://mocki.io/v1/3641bc44-2d0c-4a69-a2b7-9dcf62993ccc";
function Home({ searchTerm }) {
  const { data: products, loading, error } = useFetch(API_URL);
  const [visibleCount, setVisibleCount] = useState(6);

  // Debounce searchTerm to reduce re-renders
  const debouncedSearch = useDebounce(searchTerm, 300);

  // Filter products based on debounced search term
  const filteredProducts = products.filter((product) =>
    product.title.toLowerCase().includes(debouncedSearch.toLowerCase()),
  );

  // Infinite scroll
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 100
      ) {
        setVisibleCount((prev) => Math.min(prev + 4, filteredProducts.length));
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [filteredProducts]);

  const visibleProducts = filteredProducts.slice(0, visibleCount);

  if (loading) return <h2 style={{ textAlign: "center" }}>Loading...</h2>;
  if (error)
    return <h2 style={{ textAlign: "center" }}>Error loading products.</h2>;

  return (
    <div className="home">
      <div className="home__container">
        <img
          src="https://images.unsplash.com/photo-1488229297570-58520851e868?q=80&w=1469&auto=format&fit=crop&ixlib=rb-4.1.0"
          alt=""
          className="home__image"
        />

        {visibleProducts.length > 0 ? (
          <div className="home__row">
            {visibleProducts.map((product) => (
              <Product
                key={product.id}
                id={product.id}
                title={product.title}
                price={product.price}
                rating={product.rating}
                image={product.image}
              />
            ))}
          </div>
        ) : (
          <h2 style={{ textAlign: "center", padding: "20px" }}>
            No products found.
          </h2>
        )}
      </div>
    </div>
  );
}

export default Home;
